"use client";

import { usePathname } from "next/navigation";
import type { Locale } from "@/i18n.config";
import Footer from "./footer";

type Props = {
  locale: Locale;
  ssrData?: any;
};

export default function ConditionalFooter({ locale, ssrData }: Props) {
  const pathname = usePathname();

  // 判断是否是首页
  // 首页的路径格式: /en, /zh, /es, /fr, /de
  const isHomePage = pathname === `/${locale}` || pathname === "/";

  // 首页不显示 Footer（首页有自己的 Footer 在 HomePageClient 中）
  if (isHomePage) {
    return null;
  }

  // 其他页面显示四列布局版Footer
  return <Footer locale={locale} showForm={false} ssrData={ssrData} />;
}
